import { UseQueryOptions } from '@tanstack/react-query'
import { AxiosRequestConfig } from 'axios'

export interface HookParams {
	config?: AxiosRequestConfig
	options?: UseQueryOptions
}

export const DEFAULT_PARAMS: HookParams = {}
